import { default as ScreenSizeContextProvider } from './ScreenSizeContext.container';
import { ScreenSizeContext } from './ScreenSizeContext';
export { ScreenSizeContext };
export { ScreenSizeContextProvider };
//# sourceMappingURL=index.js.map